import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Cliente } from './cliente.model';
import { BackendService } from '../core/backend.service';
import { Saldo } from './saldo.model';

@Injectable()
export class SaldoResolver implements Resolve<Saldo> {
  constructor(
    protected router: Router,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id;

      return await this.backendService.get(Saldo, Saldo.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/clientes']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente/saldos.resolver.ts